<template>
    <div>
        <div class="divided_line">
            <hr style="">
            <button @click="open = !open">+</button>
        </div>
        <select v-model="selected" v-if="open" class="w-100 form-select">
            <option value="H1">{{ $t("component.heading1") }}</option>
            <option value="H2">{{ $t("component.heading2") }}</option>
            <option value="H3">{{ $t("component.heading3") }}</option>
            <option value="Paragraph">{{ $t("component.paragraph") }}</option>
            <option value="Input">{{ $t("component.input") }}</option>
            <option value="Table">{{ $t("component.table") }}</option>
            <option value="Row">{{ $t("component.row") }}</option>
            <option value="Column">{{ $t("component.column") }}</option>
            <option value="Multiselect">{{ $t("component.multiselect") }}</option>
            <option value="Div">{{ $t("component.div") }}</option>
            <option value="Link">{{ $t("component.link") }}</option>
            <option value="Image">{{ $t("component.image") }}</option>
            <option value="Block">{{ $t("component.block") }}</option>
            <option value="ProductRow">{{ $t("component.productRow") }}</option>
            <option value="Select">{{ $t("component.select") }}</option>
            <option value="Switch">{{ $t("component.switch") }}</option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {},
        position: {
            type: Number,
            default: 0
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            selected: null,
            open: false
        }
    },
    watch: {
        selected: function (value) {
            if (value) {
                this.value.structure.splice(this.position + 1, 0, this.createObject(value));
                this.selected = null;
                this.open = false;
            }
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    },
    methods: {
        createID: function (length) {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                counter += 1;
            }
            return result;
        },
        createObject: function(component){
            return {
                "component": component,
                "text": null,
                "id": this.createID(18),
                "class": null,
                "style": null,
                "type": null,
                "calculate": null,
                "units": null,
                "hide": false,
                "disabled": null,
                "value": null,
                "options": "",
                "placeholder": null,
                "src": null,
                "href": null,
                "target": null,
                "target_id": null,
                "structure": []
            }
        }
    }
}
</script>
<style lang="scss">
.divided_line {
    position: relative;
    hr {
        width: 100%;
        height: 2px;
        border-width:0;
        color:white;
        opacity: 1;
        background-color:white;
    }
    button {
        position: absolute;
        border-radius: 50%;
        background-color: white;
        color: black;
        padding: 0px;
        height: 20px;
        width: 20px;
        line-height: 0px;
        border: 0px;
        top: -10px;
        left: calc(50% - 10px);
    }
}
</style>